import React, { useState } from "react";
import { graphql, Link } from "gatsby";
import { getCart } from "../utils/cart";
import styled from "styled-components";
import SEO from "../components/Seo";

import Layout from "../components/Layout";
import ProductCard from "../components/ProductCard/ProductCard";
import Header from "../components/Header/Header";

// Inner Components
const Container = styled.div`
  width: 60%;
  margin: 0px auto;
  @media (max-width: 1100px) {
    width: 75%;
  }
  @media (max-width: 768px) {
    width: 85%;
  }
`;

const ConfirmButton = styled.button`
  background-color: #77C686;
  border: 1px solid #77C686;
  border-radius: 3px;
  padding: 20px 40px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  margin-bottom: 40px;
`;

const InfoContainer = styled.div`
  margin: 20px 0px;
`;

const DescriptionContainer = styled.div`
  margin: 30px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    margin: 20px 0px;
  }
`;

const MapButton = styled.button`
  background-color: #C9B79F;
  border: 1px solid #C9B79F;
  border-radius: 3px;
  padding: 5px 10px;
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  white-space: nowrap;
  margin-left: 40px;
  @media (max-width: 768px) {
    flex-direction: column;
    margin-left: 0px;
    margin-top: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 20px;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const ProducerTemplate = ({ data }) => {

  const { name, slug, products, backgroundImage, description, location } = data.producer;

  const cart = getCart();

  const [key, setKey] = useState(0);
  const updateCart = () => setKey(prevState => prevState + 1)

  return (
    <Layout cartKey={key} updateCart={updateCart}>
      <SEO
        pageTitle={name}
        description={`Página da Loja Online do produtor ${name} - Feira do Vinho do Dão`}
      />
      <Header
        title={name}
        subtitle="Loja online de"
        image={backgroundImage}
        margin="20%"
      />
      <Container>
        {description &&
          <DescriptionContainer>
            <p style={{ fontSize: '14px', color: 'rgb(200, 178, 150)', margin: '0' }}>{description}</p>
            <a target="_blank" rel="noopener noreferrer" href={`https://www.google.com/maps/place/${location.latitude},${location.longitude}`}>
              <MapButton>Ver no Mapa</MapButton>
            </a>
          </DescriptionContainer>
        }
        <InfoContainer>
          <p style={{ fontSize: '18px', color: '#707070' }}>Conheça os produtos disponíveis e selecione as quantidades que pretende encomendar. Para avançar, clique em 'Confirmar' no final da página!</p>
        </InfoContainer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {products.map(product => {
            let found = cart ? cart.products.find(p => p.id === product.id) : null;
            return (
              <ProductCard
                updateCart={updateCart}
                key={product.id}
                product={product}
                pack={found ? found.pack : null}
                producerSlug={slug}
                producerName={name}
              />
            );
          })}
        </div>
        <ButtonContainer>
          <Link to="/resume">
            <ConfirmButton>Confirmar</ConfirmButton>
          </Link>
        </ButtonContainer>
      </Container>
    </Layout>
  );
};

export const query = graphql`
  query GetSingleProducer($slug: String) {
    producer: strapiProducers(slug: { eq: $slug }) {
      name
      slug
      description
      location {
        latitude
        longitude
      }
      products {
        title
        price
        discount {
          active
          price
        }
        description
        grapeVarieties
        id
        type
        year
        producer
        image {
          childImageSharp {
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      backgroundImage {
        childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;

export default ProducerTemplate;
